import { Paper, type PaperProps } from '@mui/material';
import { Alert } from '@side/pantry';

/**
 * Builds a dropdown surface that shows an informational banner above the option
 * list. Curried because MUI's `slots.paper` type admits no extra props; callers
 * should memoize the result so the popup isn't remounted on every render.
 */
export function createFilterAutocompleteAlertPaper(alertMessage: string) {
  return function FilterAutocompleteAlertPaper({
    children,
    ...props
  }: PaperProps) {
    return (
      <Paper {...props}>
        <Alert severity="info" sx={{ mx: 1, mt: 1 }}>
          {alertMessage}
        </Alert>
        {children}
      </Paper>
    );
  };
}
